import React from 'react'
import { Card } from 'react-bootstrap'

function PoliticaDePrivacidad () {
  const politica = [
    {
      titulo: 'TqqApp',
      texto: `La aplicación TqqApp está diseñada para que los transportistas puedan ingresar el número de su ` +
                  `carta de porte o escanear su código QR para visualizar el estado de su carga en el circuito de descarga. ` +
                  `La aplicación no solicita ni recopila datos personales de los usuarios, su objetivo es ` +
                  `permitir consultar información relacionada con una carta de porte para ayudar al transportista a ` +
                  `resolver cualquier inconveniente que pueda generar demora en su descarga.`
    },
    {
      titulo: 'Alcance',
      texto: `Esta política de usuario se aplican a todos los usuarios de la aplicación TqqApp. ` +
                  `Al utilizar la aplicación, usted acepta y está de acuerdo con estas políticas.`
    },
    {
      titulo: 'No se recopilan datos personales',
      texto: `TqqApp no recopila ni almacena ningún dato personal de los usuarios. La única información ` +
                  `que se procesa es el número de carta de porte o el código QR escaneado, que se utiliza únicamente ` +
                  `para recuperar el estado de la carta de porte del sistema de la empresa que realiza la descarga. ` +
                  `No se requiere la creación de cuentas para que los usuarios puedan hacer uso de la aplicación.`
    },
    {
      titulo: 'Uso de la información',
      texto: `La información procesada por TqqApp se utiliza exclusivamente para mostrar a los usuarios ` +
                  `el estado de su carta de porte en el circuito de descarga. No se usa para ningún otro ` +
                  `propósito, la información no se comparte con terceros.`
    },
    {
      titulo: 'Acceso y modificación de datos',
      texto: `Los usuarios pueden acceder a los datos relacionados a su número de carta de porte ingresando el ` +
                  `número o escaneando el QR, no se requiere generar una cuenta ni iniciar sesión. Los usuarios no ` +
                  `tienen la posibilidad de modificar los datos procesados por TqqApp, solo pueden visualizarlos.`
    },
    {
      titulo: 'Encuesta para transportistas',
      texto: `La aplicación TqqApp ofrece a los usuarios la posibilidad de participar en una encuesta externa ` +
              `de forma voluntaria. El objetivo de esta encuesta es recopilar información para la continua mejora ` +
              `en los procesos de recepción y descarga, tales como la eficiencia de los procedimientos y la ` +
              `satisfacción del transportista. La información recopilada se utilizará exclusivamente para fines ` +
              `de análisis y mejora de nuestros servicios. La participación en la encuesta no es obligatoria ` +
              `y no condiciona el uso de la aplicación. Los datos recopilados no se compartirán con terceros y ` +
              `serán tratados solo con el fin de mejorar el proceso para el transportista.`
    },
    {
      titulo: 'Cambios en la Política',
      texto: `TqqApp se reserva el derecho de modificar esta política de privacidad en cualquier momento. ` +
                  `Las modificaciones se publicarán en la aplicación y entrarán en vigor inmediatamente después ` +
                  `de su publicación.`
    },
    {
      titulo: 'Contacto',
      texto: `Si tiene alguna pregunta o inquietud sobre estas políticas de usuario o sobre el uso de la aplicación ` +
                  `puede contactarnos a través del correo electrónico sistemastqq@gmail.com.`
    }
  ]

  const renderPolitica = () => {
    const politicaPrivacidad = politica.map((p, i) => {
      return (
        <div key={p.titulo}>
          <h6 style={{ fontWeight: 'bold' }}>{i + 1}. {p.titulo}</h6>
          <p>{p.texto}</p>
        </div>
      )
    })
    return politicaPrivacidad
  }

  return (
    <Card className='shadow rounded' style={{ margin: '2% auto', padding: '22px', width: '80%', backgroundColor: '#f1f1f1' }}>
      <h3 style={{ fontWeight: 'bold' }}>TqqApp - Política de privacidad</h3>

      <hr />
      <div style={{ textAlign: 'justify', width: '85%', margin: '2% auto' }}>
        {renderPolitica()}
      </div>
    </Card>
  )
}

export default PoliticaDePrivacidad
